import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import Popup from '../../Popup';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../CustomAlert';
import EditIcon from '@material-ui/icons/Edit';
import EyeIcon from '@material-ui/icons/RemoveRedEye';
import { Helmet } from 'react-helmet';
import { getProductAndSalesDocumentWithUserId } from '../../../Backend/firebase/product-and-sales';
import ProductAndSalesFilter from './ProductAndSalesFilter';
import UpdateProductAndSales from './UpdateProductAndSales';
import ViewProductAndSales from './ViewProductAndSales';
import { dateFormatter } from '../../Models/CommonFunc';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'ProductName', label: 'Product Name', disableSorting: true },
    { id: 'ProductType', label: 'Product Type', disableSorting: true },
    { id: 'ProductSize', label: 'Product Size', disableSorting: true },
    { id: 'HSNCode', label: 'HSN Code', disableSorting: true },
    { id: 'GSTClass', label: 'GST Class', disableSorting: true },
    { id: 'PrimaryPack', label: 'Primary Pack', disableSorting: false },
    { id: 'SecondaryPack', label: 'Secondary Pack', disableSorting: false },
    { id: 'PackConversion', label: 'Pack Conversion', disableSorting: false },
    { id: 'StockAsPerPrimaryPack', label: 'Stock (As per Primary Pack)', disableSorting: false },
    { id: 'MRPAsPerPrimaryPack', label: 'MRP (as per Primary Pack)', disableSorting: false },
    { id: 'SellingPriceAsPerPrimaryPack', label: 'Selling Price (as per primary pack)', disableSorting: false },
    { id: 'Discount', label: 'Discount', disableSorting: false },
    { id: 'SchemeQuantity', label: 'Scheme Quantity', disableSorting: false },
    { id: 'PackAsPerSchemeQuantity', label: 'Pack (as per Scheme Quantity)', disableSorting: false },
    { id: 'SchemeReward', label: 'Scheme Reward', disableSorting: false },
    { id: 'PackAsPerSchemeQuantity', label: 'Pack (as per Scheme Reward)', disableSorting: false },
    { id: 'ExpiryDate', label: 'Expiry Date', disableSorting: false },
    { id: 'action', label: 'Action', disableSorting: false },
]

function AllProductAndSales() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openPopup, setOpenPopup] = useState(false);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [updatedProductAndSalesId, setUpdatedProductAndSalesId] = useState('');
    const [uniqueProductAndSalesId, setUniqueProductAndSalesId] = useState('');
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.ProductName.toLowerCase().includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getProductsAndSales = await getProductAndSalesDocumentWithUserId(userData.uid);
                setRecords(getProductsAndSales);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get Products And Sales", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const updateProductAndSales = (_id, productAndSalesId) => {
        setUniqueProductAndSalesId(_id);
        setUpdatedProductAndSalesId(productAndSalesId);
        setOpenPopup(true);
    };

    const viewProductAndSales = (_id, productAndSalesId) => {
        setUniqueProductAndSalesId(_id);
        setUpdatedProductAndSalesId(productAndSalesId);
        setOpenViewPopup(true);
    };

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    const refreshData = async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getProductsAndSales = await getProductAndSalesDocumentWithUserId(userData.uid);
                setRecords(getProductsAndSales);
                setIsLoading(false);
                setNotificationMessage('Products And Sales data has updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
            } catch(error) {
                console.log("Error Occur in Get Products And Sales", error)
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Products And Sales you have posted till now." />
                            <title>Products And Sales | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <ProductAndSalesFilter handleFilters={handleFilters} refreshData={refreshData} />
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Products And Sales..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                {/* <TblContainer>
                                    <TblHead />
                                    <TableBody> */}
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <>
                                                    <div className="col-lg-4 col-md-4 col-sm-12 topSkills topSkills__productDisplay" key={item.id}>
                                                        <div className="card-events card-products all-products">
                                                            <div className="card-events-body d-flex flex-column background__color position__class">
                                                                <div className="product__edit">
                                                                    <Tooltip title="Edit Product And Sales" placement="top">
                                                                        <IconButton color="primary"
                                                                            onClick={() => updateProductAndSales(item._id, item.uniqueId)}>
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="View Product And Sales Record" placement="top">
                                                                        <IconButton color="primary"
                                                                            onClick={() => viewProductAndSales(item._id, item.uniqueId)}>
                                                                            <EyeIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                                <div className="party-events-details">
                                                                    <h5 className="card-events-title white__color product__mainTitle">{item.ProductName}</h5>
                                                                    <p className="card-events-title white__color">{item.ProductType}</p>
                                                                    <p className="card-events-title white__color">HSN Code: <b>{item.HSNCode ? `${item.HSNCode}` : 'NA'}</b></p>
                                                                    {item.GSTClass && <p className="card-events-title white__color">GST Class: <b>{item.GSTClass ? `${item.GSTClass}%` : '0'}</b></p>}
                                                                    {item.Discount && <p className="card-events-title white__color">Discount: <b>{item.Discount}</b></p>}
                                                                    {item.PrimaryPack && <p className="card-events-title white__color">Primary Pack: <b>{item.PrimaryPack}</b></p>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <TableRow key={item.id}>
                                                        <TableCell>{item.ProductName}</TableCell>
                                                        <TableCell>{item.ProductType ? item.ProductType : "NA"}</TableCell>
                                                        <TableCell>{item.ProductSize ? item.ProductSize == "Others" ? item.OthersProductSize : item.ProductSize : "NA"}</TableCell>
                                                        <TableCell>{item.HSNCode ? item.HSNCode : "NA"}</TableCell>
                                                        <TableCell>{item.GSTClass ? item.GSTClass : "NA"}</TableCell>
                                                        <TableCell>{item.PrimaryPack ? item.PrimaryPack : "NA"}</TableCell>
                                                        <TableCell>{item.SecondaryPack ? item.SecondaryPack : "NA"}</TableCell>
                                                        <TableCell>{item.PackConversion ? item.PackConversion : "NA"}</TableCell>
                                                        <TableCell>{item.StockAsPerPrimaryPack ? item.StockAsPerPrimaryPack : "NA"}</TableCell>
                                                        <TableCell>{item.MRPAsPerPrimaryPack ? item.MRPAsPerPrimaryPack : "NA"}</TableCell>
                                                        <TableCell>{item.SellingPriceAsPerPrimaryPack ? item.SellingPriceAsPerPrimaryPack : "NA"}</TableCell>
                                                        <TableCell>{item.Discount ? `${item.Discount}%` : "NA"}</TableCell>
                                                        <TableCell>{item.SchemeQuantity ? item.SchemeQuantity : "NA"}</TableCell>
                                                        <TableCell>{item.PackAsPerSchemeQuantity ? item.PackAsPerSchemeQuantity : "NA"}</TableCell>
                                                        <TableCell>{item.SchemeReward ? item.SchemeReward : "NA"}</TableCell>
                                                        <TableCell>{item.PackAsPerSchemeReward ? item.PackAsPerSchemeReward : "NA"}</TableCell>
                                                        <TableCell>{item.ExpiryDate ? <>{typeof item.ExpiryDate == "string" ? item.ExpiryDate : dateFormatter(item.ExpiryDate.toDate().toString())}</> : "NA"}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Edit Product And Sales Record" placement="top">
                                                                <IconButton color="secondary"
                                                                    onClick={() => updateProductAndSales(item._id, item.uniqueId)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="View Product And Sales Record" placement="top">
                                                                <IconButton color="secondary"
                                                                    onClick={() => viewProductAndSales(item._id, item.uniqueId)}>
                                                                    <EyeIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow> */}
                                                </>
                                            ))
                                        }
                                    {/* </TableBody>
                                </TblContainer> */}
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Products And Sales Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Update Product And Sales Record" popupSize="lg">
                <UpdateProductAndSales _id={uniqueProductAndSalesId} productAndSalesId={updatedProductAndSalesId} setOpenPopup={setOpenPopup} refreshData={refreshData} />
            </Popup>

            <Popup openPopup={openViewPopup} setOpenPopup={setOpenViewPopup} title="View Product And Sales Record" popupSize="md">
                <ViewProductAndSales productAndSalesId={updatedProductAndSalesId} />
            </Popup>
        </>
    )
}

export default AllProductAndSales
